// extracted by mini-css-extract-plugin
export default {"circle":"PreloaderCircle_circle_s72vP","spin":"PreloaderCircle_spin_vm4S9"};